import { Card, CardBody, Col, Input, Table } from "reactstrap";
import { CurrentOrdersTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import OrderBody from "./OrderBody";

const CurrentOrders = () => {
  return (
    <Col xxl="6" lg="8" className="box-col-8e">
      <Card>
        <DashboardCommonHeader title={CurrentOrdersTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="px-0 recent-order">
          <div className="table-responsive custom-scrollbar">
            <Table className="display" id="recent-order">
              <thead>
                <tr>
                  <th>
                    <div className="form-check">
                      <Input type="checkbox" />
                    </div>
                  </th>
                  <th>Customers name</th>
                  <th>Order Date</th>
                  <th>items Name</th>
                  <th>Price</th>
                  <th>Status</th>
                </tr>
              </thead>
              <OrderBody />
            </Table>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CurrentOrders;
